import axios from "axios";
import http from "@/api";
import { nameService, snakeService, conf_actions, conf_auto } from "@/autolib/config.js";

var state = (name) => {
    var data = {};
    conf_auto.forEach(ca=> {
        const service = ca.target == "self" ? "" : ca.target;
        data[nameService([name, "use-api-group", service])] = true;
        data[nameService([name, "api-route", service])] = "/api";
        Object.keys(ca.data).forEach(key => {
            data[nameService([name, key, "reload-callback-counter", service])] = 0;
            data[nameService([name, key, "reload-everywhere-counter", service])] = 0;
            data[nameService([name, key, "reload-somewhere-list", service])] = [];
            data[nameService([name, key, "state", service])] = ca.data[key];
        });
    });
    return data;
};

var mutations = (name) => {
    var data = {};

    // Service or Contact
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;

        // Self or Array
        Object.keys(conf_actions).forEach(key => {

            // Update reload counter (event shared by watch service)
            data[nameService([name, key, "reload-evw-smw", service])] = function(state, somewhere){
                state[nameService([name, key, "reload-everywhere-counter", service])]++;
                if(somewhere){
                    var smw = nameService([name, key, "reload-somewhere-list", service]);
                    state[smw] = state[smw].concat(somewhere);
                }
            }

            data[nameService([name, key, "reload-callback-signal", service])] = function(state){
                state[nameService([name, key, "reload-callback-counter", service])]++;
            }

            // Remove reload somewhere (after reload accepted)
            data[nameService([name, key, "remove-smw", service])] = function(state, comp_name){
                const pos = state[nameService([name, key, "reload-somewhere-list", service])].indexOf(comp_name);
                if(pos > -1) state[nameService([name, key, "reload-somewhere-list", service])].splice(pos, 1);
            }

            conf_actions[key].forEach(a => {
                var fctn = nameService([name, a, key, "state", service]);
                if(a == "reset"){
                    data[snakeService(fctn)] = function(state) {
                        ca.data.forEach(st => {
                            state[nameService(name, st, "state", service)] = st == "array" ? [] : {};
                        })
                    }
                }else{
                    data[snakeService(fctn)] = function(state, {response, payload}) {
                        if(key == "array"){
                            if(Array.isArray(response)){
                                state[nameService([name, "array-state", service])] = response;
                            }else if(response.results){
                                state[nameService([name, "array-state", service])] = response.results;
                                delete response.results;
                                state[nameService([name, "api-state", service])] = response;
                                if(response.stats) state[nameService(name, "stats-state", service)] = response.stats;
                            }
                            state[nameService([name, "payload-state", service])] = payload;
                        }else {
                            state[nameService([name, "self-state", service])] = response;
                        }
                    }
                }
            });
        });
    });
    return data;
};

var getters = (name) => {
    var data = {};
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        data[nameService([name, "http", service])] = () => { return http; };
        data[nameService([name, "get-api", service])] = (state, getters, rootState, rootGetters) =>
            ({prefix, id, url, action, apigroup, disable_apigroup}) => {
            var base = "/api";
            if(state[nameService([name, "use-api-group", service])] && !disable_apigroup){
                base = apigroup ? base+"/"+apigroup : rootGetters['User/apiGroup'];
            }
            base += prefix ? prefix : "";
            base += state[nameService([name, "endpoint"])];
            var ext = service ? state[nameService([name, "endpoint", service])] : "";
            var add = [id, url, ext, action].filter(u => u);
            base += add.join("/");
            return add.length ? base + "/" : base;
        };
        data[nameService([name, "get-api-detail", service])] = (state, getters) => ({prefix, id, apigroup, disable_apigroup}) => {
            return id ? getters[nameService([name, "get-api", service])]({ prefix, id, apigroup, disable_apigroup }) : null;
        };
        data[nameService([name, "get-api-form", service])] = (state, getters) => ({prefix, id, form, apigroup, disable_apigroup}) => {
            return getters[nameService([name, "get-api", service])]({prefix, id, url: "forms", action: form, apigroup, disable_apigroup})
        };
        data[nameService([name, "get-api-form-detail", service])] = (state, getters) => ({prefix, id, form, apigroup, disable_apigroup}) => {
            return getters[nameService([name, "get-api", service])]({prefix, id, url: "formsdetail", action: form, apigroup, disable_apigroup})
        };
        data[nameService([name, "filter-by", service])] = (state) => (field, value, arr) => {
            arr = arr || state[nameService(name, "array-state", service)];
            return arr.filter(x => x[field] == value);
        };
        data[nameService([name, "find-by", service])] = (state) => (field, value, arr) => {
            arr = arr || state[nameService(name, "array-state", service)];
            return arr.find(x => x[field] == value);
        };
        data[nameService([name, "filter-multiple-by", service])] = (state) => (by, arr) => {
            arr = arr || state[nameService(name, "array-state", service)];
            var keys = Object.keys(by);
            return arr.filter(x => keys.every(key => key in x && x[key] == by[key]));
        };
        data[nameService([name, "find-multiple-by", service])] = (state) => (by, arr) => {
            arr = arr || state[nameService(name, "array-state", service)];
            var keys = Object.keys(by);
            return arr.find(x => keys.every(key => key in x && x[key] == by[key]))
        };
    });
    return data;
};

var actions = (name) => {
    var data = {};

    data[nameService([name, "upload-document"])] = async function({ getters }, {file, id, params}){
        const api = getters[nameService([name, "get-api"])]({ id, url: "add_document" });
        var payload = Object.assign({ file }, params);
        const response = await http.postForm(api, payload);
        return response.data;
    };
    data[nameService([name, "remove-document"])] = async function({ getters }, {id}){
        const api = getters[nameService([name, "get-api"])]({ id, url: "delete_document" });
        const response = await http.delete(api);
        return response.data;
    };
    data[nameService([name, "download-document"])] = async function({getters}, {id, payload, method, filename}){
        const api = getters[nameService([name, "get-api"])]({ id, url: "doc_download" });
        payload = payload || {};
        payload.responseType = 'arraybuffer';
        const response = await http[method || "get"](api, payload);
        var cd = response.headers["content-disposition"];
        const fn = filename || cd.match("filename=(.+)")[1]
        const blob = new Blob([response.data], {});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fn;
        link.click();
        URL.revokeObjectURL(link.href);
    }

    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;

        data[nameService([name, "http-request", service])] = async function({api, payload, method}){
            const response = await http[method || "get"](api, payload);
            return response.data;
        }

        Object.keys(conf_actions).forEach(key => {
            var get_fctn = nameService([name, "get", key, "state", service]);

            data[nameService([name, key, "crud-evw-smw", service])] = function({ commit }, somewhere){
                commit(nameService([name, key, "reload-evw-smw", service]), somewhere);
            }

            data[nameService([name, key, "crud-callback", service])] = function({ commit }){
                commit(nameService([name, key, "reload-callback-signal", service]));
            }

            data[nameService([name, key, "remove-somewhere", service])] = async function({ commit }, comp_name){
                commit(nameService([name, key, "remove-smw", service]), comp_name);
            }

            data[nameService([name, key, "url-customize", service])] = async function({getters},
                {prefix, id, url, action, payload, method, apigroup, disable_apigroup}){
                const api = getters[nameService([name, "get-api", service])]({ prefix, id, url, action, apigroup, disable_apigroup });
                const response = await http[method || "get"](api, payload);
                return response.data;
            }

            data[nameService([name, key, "single-action", service])] = async function({getters}, {id, action, payload, method}){
                const api = getters[nameService([name, "get-api", service])]({ id, url: "saction/"+action });
                const response = await http[method || "get"](api, payload);
                return response.data;
            }

            data[nameService([name, key, "reporting-list", service])] = async function({getters}, {id, payload, method}){
                const api = getters[nameService([name, "get-api", service])]({ id, url: "reporting_list" });
                const response = await http[method || "get"](api, payload);
                return response.data;
            }

            data[nameService([name, key, "reporting-detail", service])] = async function({getters}, {id, payload, method}){
                payload.responseType = 'arraybuffer';
                const api = getters[nameService([name, "get-api", service])]({ id, url: "reporting_detail" });
                const response = await http[method || "get"](api, payload);
                var cd = response.headers["content-disposition"];
                const fn = cd.match("filename=(.+)")[1]
                const blob = new Blob([response.data], {});
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fn;
                link.click();
                URL.revokeObjectURL(link.href);
            },

            data[nameService([name, key, "reporting-global", service])] = async function({getters}, {payload, method}){
                payload.responseType = 'arraybuffer';
                const api = getters[nameService([name, "get-api", service])]({url: "reporting_global" });
                const response = await http[method || "get"](api, payload);
                var cd = response.headers["content-disposition"];
                const fn = cd.match("filename=(.+)")[1]
                const blob = new Blob([response.data], {});
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fn;
                link.click();
                URL.revokeObjectURL(link.href);
            },


            data[nameService([name, "create", key, "state", service])] = async function({getters}, {id, payload, url}){
                const api = getters[nameService([name, "get-api", service])]({ id, url });
                const response = await http.post(api, payload);
                //if(!notcommit) commit(snakeService(fctn), {response: response.data, payload});
                return response;
            }

            data[nameService([name, "create-or-update", key, "state", service])] = async function({getters}, {id, payload, url}){
                const api = getters[nameService([name, "get-api", service])]({ id, url });
                const response = await http[id ? "put" : "post"](api, payload);
                //if(!notcommit) commit(snakeService(fctn), {response: response.data, payload});
                return response;
            }

            conf_actions[key].forEach(a => {
                var fctn = nameService([name, a, key, "state", service]);
                switch(a){
                    case "set":
                        data[fctn] = async function({dispatch, commit},
                            {prefix, id, payload, url, next, method, notcommit, apigroup, disable_apigroup}){
                            const response = await dispatch(get_fctn,  {prefix, id, payload, url, next, method, apigroup, disable_apigroup});
                            if(!notcommit) commit(snakeService(fctn), {response: response.data, payload});
                            return response;
                        }
                        break;
                    case "update":
                        data[fctn] = async function({commit, getters},
                            {prefix, id, payload, url, notcommit, somewhere, apigroup, disable_apigroup}){
                            const api = getters[nameService([name, "get-api", service])]({ prefix, id, url, apigroup, disable_apigroup });
                            const response = await http.put(api, payload);
                            if(!notcommit){
                                const cmt = nameService([name, "set", key, "state", service]);
                                commit(snakeService(cmt), {response: response.data, payload});
                            }
                            // Event object(s) can be reload
                            commit(nameService([name, key, "reload-evw-smw", service]), somewhere)
                            return response;
                        }
                        break;
                    case "delete":
                        data[fctn] = async function({commit, getters},
                            {prefix, id, payload, url, somewhere, apigroup, disable_apigroup}){
                            const api = getters[nameService([name, "get-api", service])]({ prefix, id, url, apigroup, disable_apigroup });
                            const response = await http.delete(api, payload);
                            // dispatch(nameService([name, "reset", key, "state", service]));
                            // Event object(s) can be reload
                            commit(nameService([name, key, "reload-evw-smw", service]), somewhere)
                            return response;
                        }
                        break;
                    case "reset":
                        data[fctn] = function({commit}){ commit(snakeService(fctn)); }
                        break;
                    case "reload":
                        data[fctn] = async function({state, dispatch, commit},
                            {prefix, id, payload, url, notcommit, apigroup, disable_apigroup}){
                            if(!payload) payload = {};
                            Object.assign(payload, state[nameService([name, "payload-state", service])])
                            const response = await dispatch(get_fctn, {prefix, id, payload, url, apigroup, disable_apigroup});
                            if(!notcommit) commit(snakeService(fctn), {response: response.data, payload});
                            return response;
                        }
                        break;
                    default:
                        data[fctn] = async function({getters},
                            {prefix, id, payload, url, next, method, apigroup, disable_apigroup}){
                            const api = getters[nameService([name, "get-api", service])]({ prefix, id, url, apigroup, disable_apigroup});
                            const response = await http[method || "get"](next || api, payload)
                                .catch(function (thrown) {
                                    if (axios.isCancel(thrown)) {
                                        return { data: { results: []}};
                                    }
                                });
                            return response;
                        }
                }
            })
        });
    });
    return data;
};

export default function(name, store, service, { endpoint, isPaginate, limit }) {
    var newState = {};
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        newState[nameService([name, "endpoint", service])] = ca.target == "self" ? endpoint : "contacts";
        newState[nameService([name, "is-paginate", service])] = isPaginate;
        newState[nameService([name, "page", "limit", service])] = limit || 50;
    });
    return {
        namespaced: true,
        state: Object.assign(newState, state(name), service.state),
        mutations: Object.assign(mutations(name), service.mutations),
        getters: Object.assign(getters(name), service.getters),
        actions: Object.assign(actions(name), service.actions),
    };
}
